<div
	ngClass="p-xxl"
	ngClass.sm="p-m"
	ngClass.xs="p-s"
	fxLayout="row"
	fxFlex="100%"
	fxLayoutAlign="center start"
>
	<img
		style="width: 100px; height: 100px"
		class="page-loader"
		src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/whydonate_icon/public"
	/>
</div>
